import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import { GraduationCap as Graduation } from "lucide-react";
import "./BatchCard.css";

const BatchCard = ({ batch }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/CollegeDashboard`, {
      state: {
        batch_id: batch.ug_id,
      },
    });
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        borderRadius: 2,
        boxShadow: 1,
        width: "370px",
        transition: 'transform 0.2s, box-shadow 0.2s',
        // '&:hover': {
        //   transform: 'translateY(-4px)',
        //   boxShadow: 2,
        // },
        overflow: 'visible',
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: '#E0F7FA',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mr: 1.5,
            }}
          >
            <Graduation size={24} color="#007C91" />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px" }}>
              {batch.ug_name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: "14px" }}>
              CEE Batch Analysis & Placement Insights
            </Typography>
          </Box>
        </Box>

        <Button
          variant="contained"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            width: "100%",
            background: "#1c8ea8",
            fontSize: "16px",
            boxShadow: 2,
            '&:hover': { boxShadow: 4, background: "rgba(28, 142, 168, 0.9)", },
          }}
        >
          View Details
        </Button>
      </CardContent>
    </Card>
  );
};

export default BatchCard;
